import ReactGA from 'react-ga'

export const initializeGA = (pathname: string) => {
  if (process.env.NODE_ENV !== 'production') return null
  const trackingId = 'G-YFLZW883K5'
  ReactGA.initialize(trackingId)
  ReactGA.pageview(pathname)
}
